/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteSetExternalIdentifierModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
}>;


export type QuoteSetExternalIdentifierModalQuery = { quoteExternalIdentifier?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteExternalIdentifier', id: string, externalIdentifier: string } | null };

export type SetQuoteExternalIdentifierMutationVariables = Types.Exact<{
  input: Types.SetQuoteExternalIdentifierInput;
}>;


export type SetQuoteExternalIdentifierMutation = { setQuoteExternalIdentifier: { __typename: 'SetQuoteExternalIdentifierResult', quoteExternalIdentifier?: { __typename: 'QuoteExternalIdentifier', id: string, externalIdentifier: string } | null } };


export const QuoteSetExternalIdentifierModalDocument = gql`
    query QuoteSetExternalIdentifierModal($projectId: ID!, $docId: ID!) {
  quoteExternalIdentifier(projectId: $projectId, docId: $docId) {
    ... on QuoteExternalIdentifier {
      id
      externalIdentifier
    }
  }
}
    `;

/**
 * __useQuoteSetExternalIdentifierModalQuery__
 *
 * To run a query within a React component, call `useQuoteSetExternalIdentifierModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteSetExternalIdentifierModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteSetExternalIdentifierModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useQuoteSetExternalIdentifierModalQuery(baseOptions: Apollo.QueryHookOptions<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables> & ({ variables: QuoteSetExternalIdentifierModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>(QuoteSetExternalIdentifierModalDocument, options);
      }
export function useQuoteSetExternalIdentifierModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>(QuoteSetExternalIdentifierModalDocument, options);
        }
export function useQuoteSetExternalIdentifierModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>(QuoteSetExternalIdentifierModalDocument, options);
        }
export type QuoteSetExternalIdentifierModalQueryHookResult = ReturnType<typeof useQuoteSetExternalIdentifierModalQuery>;
export type QuoteSetExternalIdentifierModalLazyQueryHookResult = ReturnType<typeof useQuoteSetExternalIdentifierModalLazyQuery>;
export type QuoteSetExternalIdentifierModalSuspenseQueryHookResult = ReturnType<typeof useQuoteSetExternalIdentifierModalSuspenseQuery>;
export type QuoteSetExternalIdentifierModalQueryResult = Apollo.QueryResult<QuoteSetExternalIdentifierModalQuery, QuoteSetExternalIdentifierModalQueryVariables>;
export const SetQuoteExternalIdentifierDocument = gql`
    mutation SetQuoteExternalIdentifier($input: SetQuoteExternalIdentifierInput!) {
  setQuoteExternalIdentifier(input: $input) {
    quoteExternalIdentifier {
      id
      externalIdentifier
    }
  }
}
    `;
export type SetQuoteExternalIdentifierMutationFn = Apollo.MutationFunction<SetQuoteExternalIdentifierMutation, SetQuoteExternalIdentifierMutationVariables>;

/**
 * __useSetQuoteExternalIdentifierMutation__
 *
 * To run a mutation, you first call `useSetQuoteExternalIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuoteExternalIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuoteExternalIdentifierMutation, { data, loading, error }] = useSetQuoteExternalIdentifierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetQuoteExternalIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<SetQuoteExternalIdentifierMutation, SetQuoteExternalIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuoteExternalIdentifierMutation, SetQuoteExternalIdentifierMutationVariables>(SetQuoteExternalIdentifierDocument, options);
      }
export type SetQuoteExternalIdentifierMutationHookResult = ReturnType<typeof useSetQuoteExternalIdentifierMutation>;
export type SetQuoteExternalIdentifierMutationResult = Apollo.MutationResult<SetQuoteExternalIdentifierMutation>;
export type SetQuoteExternalIdentifierMutationOptions = Apollo.BaseMutationOptions<SetQuoteExternalIdentifierMutation, SetQuoteExternalIdentifierMutationVariables>;